import { render, staticRenderFns } from "./OrderBatchReview.vue?vue&type=template&id=d1084dfa&lang=pug&"
import script from "./OrderBatchReview.vue?vue&type=script&lang=js&"
export * from "./OrderBatchReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports